import { Injectable, Inject, forwardRef } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { SimpleMQ } from 'ng2-simple-mq';
import 'rxjs/Rx';
import * as _ from 'lodash';
import * as fileSaver from 'file-saver';

import { CommonService } from './common.service';
import { SocketService } from './socket.service';

@Injectable()
export class AvanzaPraticheService {
	headers: HttpHeaders;
	headersPDF: HttpHeaders;
	requestUrl: string = '/api/pratiche/avanza';
	downloadsUrl: string = '/api/downloads/pratiche';
	downloadUrl: string = '/api/downloads/pratica';
	filename: string;
	zipName: string;
	completato: boolean = false;

	public lavorazione: number = 0;
	public totali: number = 0;

	constructor(private commonService: CommonService, private smq: SimpleMQ) {
		this.smq.subscribe('avanza-pratiche', e => this.receiveMsg(e));
		this.headers = new HttpHeaders()
			.append('Content-Type', 'application/json')
			.append('Accept', 'application/json');

		this.headersPDF = new HttpHeaders()
			.append('Content-Type', 'application/json')
			.append('Accept', 'application/json')
			.append('responseType', 'blob');

		let socketService = this.commonService.getSocket();
		//console.log("SRV|AVP - SocketService", socketService);

		socketService.on('inizioAvanzaPratiche', (clientId) => {
			console.log('SRV|AVP - INIZIO AVANZA PRATICHE: ', clientId);
		});

		socketService.on('statusPratiche', (lavorazione) => {
			console.log(lavorazione, 'pratiche completate');
			this.lavorazione = lavorazione + 1;
		});

		socketService.on('fineAvanzaPratiche', (zipName) => {
			console.log('SRV|AVP - FINE AVANZA PRATICHE');
			this.praticheCompletate(zipName);
		});
	}

	receiveMsg(m) {
		console.log('SRV|AVP - receiveMsg:', m);
		if(m){
			switch(m.type){
				case 'richiesta':
					this.riceviRichiesta(m)
					break;
				case 'risposta':
					this.riceviRisposta(m);
					break;
				default:
					this.riceviFunzione(m);
			}
		}
	}

	riceviRichiesta(m){
		switch(m.key){
			/*case 'pageOpened':
				this.sendMsg(m.sender, 'risposta', m.key, this.pageOpened);
				break;*/
			default:
				console.log('SRV|AVP - riceviRichiesta: class', this);
		}
	}

	riceviRisposta(m){
		let msgSender = m.sender;
		let msgType = m.type;
		let msgKey = m.key;
		let msgValue = m.value;

		console.log('SRV|AVP - riceviRisposta: class', this);
	}

	riceviFunzione(m){
		let msgSender = m.sender;
		let msgType = m.type;
		let msgKey = m.key;
		let msgValue = m.value;
		switch(msgType){
			/*case 'cambioComune':{
				//console.log('SRV|AVP - cambioComune:', msgKey, msgValue);
				if(msgKey == 'idComune'){
					this.cambioComune(msgValue);
				}
				break;
			}*/
			default:
		}
		console.log('SRV|AVP - riceviFunzione: class', this);
	}

	sendMsg(name: string, type: any, key: any, value: any = null) {
		// Publish to queue name
		let m = {
			sender: 'avanza-pratiche',
			type: type,
			key: key,
			value: value,
		};
		console.log('SRV|AVP - sendMsg:', m);
		this.smq.publish(name, m);
	}

	mandaAvanti(datiPratiche: any) {
		console.log('SRV|AVP - mandaAvanti: ', datiPratiche);
		this.completato = false;
		this.totali = datiPratiche.uids.length;

		this.sendMsg('data', "setLoading", "loading", true);

		console.log('SRV|AVP - BODY: ', datiPratiche);
		this.filename = datiPratiche.nomeComune+'_'+datiPratiche.nomeAtto+'_';
		let min_prat = datiPratiche.primoAtto;
		let max_prat = datiPratiche.ultimoAtto;
		console.log('SRV|AVP - MIN-MAX: ', min_prat , max_prat);
		this.filename += min_prat;
		if(min_prat != max_prat)
			this.filename += '-' + max_prat;

		this.filename += '_'+ Date.now()+'.zip';

		let body = JSON.stringify(datiPratiche);
		console.log('SRV|AVP - BODY MANDA AVANTI',body);
		console.log('SRV|AVP - BODY MANDA AVANTI BIS', this.requestUrl, body, { headers: this.headers });

		this.commonService.getHttpClient().post<any>(this.requestUrl, body, { headers: this.headers })
			.subscribe(
				(error) => { console.log(error); },
				(response) => {
					console.log("SRV|AVP - response:", response);
				}
			);
	}

	praticheCompletate(zipName: string) {
		this.sendMsg('data', "refreshData", "what", 'avanza_pratica');
		this.zipName = zipName;
		this.completato = true;
	}

	scaricaPratiche() {
		let body = JSON.stringify({zipName: this.zipName});

		this.commonService.getHttpClient().post<any>(this.downloadsUrl, body, { headers: this.headersPDF })
			.subscribe(
				(response) => {
					/*console.log(response);
					let blob = new Blob([response.blob()], {type:'application/zip'});
					fileSaver.saveAs(blob, this.filename);*/

					console.log("scaricaPratiche response", response);
					let blob = response;
					fileSaver.saveAs(blob, this.zipName);
					this.sendMsg('data', "setLoading", "loading", false);
				}
			);
	}

	scaricaPratica(filePath: string, fileName: string){
		let body = JSON.stringify({
			fileName: fileName,
			filePath: filePath,
		});
		console.log("scaricaPratica", body, this.headersPDF);
		this.commonService.getHttpClient().post<any>(this.downloadUrl, body, { headers: this.headersPDF })
			.subscribe(
				(response) => {
					console.log("scaricaPratica response", response);
					let blob = response;
					let zipName = fileName.split('.')[0]+'.zip';
					console.log("zipName", zipName, blob);
					fileSaver.saveAs(blob, zipName);
				}
			);
	}
}
